var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Column, Row } from "react-vcomponents";
import { ShapeType } from "Store/firebase/mapObjects/Components/@ShapeComp";
import { BoxGeometry_PivotAtX } from "Utils/UI/ThreeJS/General";
import * as THREE from "three";
import { ToVector3 } from "Utils/General/Others";
import { Vector2i } from "js-vextensions";
import { Observer } from "vwebapp-framework";
import { ToolUI } from "./Tool";
let EditPoints = class EditPoints extends ToolUI({}, {}) {
    render() {
        //const shape: State("main", "write", "tools", "addObject", "shape"),
        return (React.createElement(Column, null,
            React.createElement(Row, null)));
    }
    RenderForObject(obj) {
        if (obj.shape == null || ![ShapeType.Path, ShapeType.Region].Contains(obj.shape.type))
            return;
        return (
        /*<group>
            {*/ obj.shape.pathPoints.map((point, index) => {
            //let color = new THREE.Color(obj.shape.color ? `rgba(${obj.shape.color})` : `rgba(255,0,0,1)`);
            const color = new THREE.Color(`rgba(255,255,0,1)`);
            const sixPixels = this.MapScene.PixelLengthInMeters() * 6;
            return (React.createElement("mesh", { key: index, position: ToVector3(obj.position.As(Vector2i).Plus(point.As(Vector2i))), rotation: new THREE.Euler() },
                React.createElement(BoxGeometry_PivotAtX, { width: sixPixels, height: sixPixels, depth: 1, pivotPoint_rel: new Vector2i(.5, .5) }),
                React.createElement("meshBasicMaterial", { color: color })));
        }) /*}
        </group>*/);
    }
};
EditPoints = __decorate([
    Observer
], EditPoints);
export { EditPoints };
